import NumberFormat, { NumberFormatProps } from 'react-number-format';
import React from 'react';
import { observer } from 'mobx-react';
import { Grid, Typography } from '@mui/material';
import { CustomOutlinedInput } from '../../shared/custom-outlined-input/CustomOutlinedInput';

interface IProps extends NumberFormatProps {
  inputLabel: string;
  inputLabelSub?: string;
  isSecond?: boolean;
  paddingLeft?: number;
  paddingRight?: number;
}
export const FormInput: React.FC<IProps> = observer((props) => {
  const { inputLabel, paddingLeft = 0, paddingRight = 0, ...numberFormatProps } = props;

  return (
    <Grid
      item={true}
      container={true}
      direction={'column'}
      alignItems={'flex-start'}
      xs={12}
      sm={6}
      paddingY={1}
      paddingLeft={paddingLeft}
      paddingRight={paddingRight}
    >
      <Typography marginBottom={0.5}>
        {inputLabel} &nbsp;
        {props.inputLabelSub && (
          <span style={{ fontWeight: 'normal', fontStyle: 'italic' }}>{props.inputLabelSub}</span>
        )}
      </Typography>

      <NumberFormat
        {...numberFormatProps}
        style={{ backgroundColor: 'white' }}
        fullWidth={true}
        size={'small'}
        color={'info'}
        thousandSeparator={true}
        customInput={CustomOutlinedInput}
        isNumericString={true}
      />
    </Grid>
  );
});
